import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useUser } from '@clerk/nextjs';
declare global {
  interface Window {
    fpr?: (...args: unknown[]) => void;
  }
}

/**
 * Tracks the signed-up user as a FirstPromoter referral.
 * Should be called once after the user is authenticated.
 * This links the user's email to any referral cookie (fpr param) that was set.
 */
export function useFirstPromoterIdentify() {
  const $ = _c(4);
  const {
    user,
    isLoaded
  } = useUser();
  let t0;
  let t1;
  if ($[0] !== isLoaded || $[1] !== user) {
    t0 = () => {
      if (!isLoaded || !user) {
        return;
      }
      if (!window.fpr) {
        return;
      }
      const email = user.primaryEmailAddress?.emailAddress;
      if (!email) {
        return;
      }
      window.fpr("referral", {
        email,
        uid: user.id
      });
    };
    t1 = [isLoaded, user];
    $[0] = isLoaded;
    $[1] = user;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}